import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Santiago', 'Camila', 'Mateo', 'Valentina', 'Lucas', 'Sofía', 'Nicolás', 'Martina', 'Joaquín', 'Julieta', 'Facundo', 'Micaela', 'Tomás', 'Florencia', 'Agustín', 'Rocío'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'San Salvador de Jujuy'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 15000); // Show first one sooner (15s) to demonstrate feature
    // Regular interval (approx 1.5 mins = 90000ms)
    const interval = setInterval(() => {
      triggerPopup();
    }, 90000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    // Pick random name and city
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Auto dismiss after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-242">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-4 border-l-4 border-[#F59E0B] max-w-sm" data-id="element-243">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-244">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-245" />
        </div>
        <div data-id="element-246">
          <p className="text-sm font-medium text-gray-900" data-id="element-247">
            <span className="font-bold" data-id="element-248">{data.name}</span> de{' '}
            <span className="font-bold" data-id="element-249">{data.city}</span>
          </p>
          <p className="text-xs text-gray-500" data-id="element-250">acaba de comprar este pack</p>
        </div>
      </div>
    </div>;
}